export default "__VITE_ASSET__CviB6tZp__"